import styled from 'styled-components';
import {typographyStyles} from '../../../utils/styles';

const StyledDotAmountList = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  width: 100%;
`;

const StyledDotAmountListItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  &:not(:last-of-type) {
    margin-bottom: 8px;
  }
`;

const StyledDotAmountListItemDot = styled.span`
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: ${({ color }) => color};
`;

const StyledDotAmountListItemName = styled.span`
  ${typographyStyles.footnote.description};

  color: ${props => props.theme.colors.neutral_7};
  flex: 1;
  line-height: 20px;
  letter-spacing: 0;
`;

const StyledDotAmountListItemValue = styled.span`
  ${typographyStyles.footnote.medium};

  color: ${props => props.theme.colors.neutral_10};
  margin-left: 8px;
`;

export {
  StyledDotAmountList,
  StyledDotAmountListItem,
  StyledDotAmountListItemDot,
  StyledDotAmountListItemName,
  StyledDotAmountListItemValue,
}
